<template>
	<div class="wrap">
		<div class="bonus-top">
			<div class="slider-item red">
				<div class="head">个人罚币</div>
				<div class="main">罚币：<span>{{ summary || 0 }}</span>币</div>
			</div>
	
			<div class="bonus-top-bottom">
				<div>
					<el-date-picker class="top-choose" v-model="datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<span>罚单类型：</span>
					<el-select class="top-choose" v-model="typeId" clearable placeholder="请选择">
						<el-option v-for="item in personalTicket" :key="item.id" :value="item.id" :label="item.ticket_name">
						</el-option>
					</el-select>
					<div class='front-btn green shift' @click="search()">查询</div>
				</div>
			</div>
		</div>
	
		<div class="bonus-bottom" id="bonusBottom">
			<div class="bonus-bottom-title">罚单明细</div>
			<ticketTable :dataList="dataList"></ticketTable>
		</div>
		<z-pagination class="inside" @getPage="search" :data='data'></z-pagination>
	</div>
</template>

<script type="text/ecmascript-6">
import ticketTable from 'src/components/ticketTable.vue'

import { mapGetters,mapState } from 'vuex'
import { getUser,lastYearDate } from 'src/control/common.js';  //公共方法

export default {
	components: {
		ticketTable,
	},
	data() {
		return {
			summary: "",  //罚单币总额
			datePick_start:"",  //选择起始时间
			datePick_end:"",   //选择终止时间
			typeId:"",   //类型id
			data:{},  //罚单数据
		}
	},
	computed: {
		...mapState(["picker_special",'personalTicket']),
		dataList(){
			return this.data.list;
		},
	},
	watch:{
		datePick_start(val){
			if(val != ""){
				let chooseDate = new Date(val);
				let lastDate = lastYearDate();

				if(chooseDate - lastDate < 0){
					this.datePick_start = lastDate;
				}
			}
		}
	},
	created() {
		this.getPage();
		this.$func.getPersonalTicket(true);

	},
	methods: {
		getPage() {
			this.getSum();
			this.search();
		},
		getSum() {
			this.$http.get("api/clerk/ticket_sum/now").then(res => {
				if(res.status == 200){
					this.summary = res.res_data;
				}
			});
		},
		refresh(obj = {}){  //拉数据
			let url = "api/clerk/ticket_detail";
			this.$http.get(url,{params:obj}).then(res=>{
				if(res.status == 200){
					this.data = res.res_data;
				}
			})
		},
		search(page){    //搜索
			let obj = {
				page:page,
				start_date:this.datePick_start,
				end_date:this.datePick_end,
				ticket_category_id:this.typeId,
			}

			if(obj.start_date == ""){
				obj.start_date = lastYearDate();
			}
			this.refresh(obj);
		},
		
	},

};

</script>

<style lang="less" scoped>
@import "~src/assets/less/var.less";
.wrap {
	background: #ffffff;
	box-shadow: 0px 0px 4px 0px rgba(127, 127, 127, 0.50);
	height: 100%;
	position: relative;

	.bonus-top {
		.num {
			position: absolute;
			left: 0;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			height: 36px;
			font-size: 36px;
			line-height: 36px;
			color: #ff6b6b;
			letter-spacing: 4px;
			text-align: center;
			margin-top: 0px;
		}
	}

	// 罚币块
	.slider-item.red{
		// @color: #FF5662;
		@color: #8391a5;
		border-color:@color;
		.head{
			background:@color;
		}
		.main{
			color:@color;
			>span{
				color:@red;
			}
		}
	}


}

.bonus-top {
	padding: 20px 20px 0;
}

.bonus-top li {
	display: inline-block;
	border: 1px solid #d2deee;
	width: 226px;
	height: 138px;
	position: relative;
	margin-right: 10px;
	margin-bottom: 10px;
}

.bonus-top li>span {
	font-size: 12px;
	text-align: left;
	position: absolute;
	left: 10px;
	top: 10px;
	color: #01b6ad;
	letter-spacing: 0.99px;
}

.bonus-top li>p {
	text-align: center;
	margin-top: 42px;
	font-size: 14px;
	color: #7f7f7f;
	letter-spacing: 1.55px;
}



.bonus-top-bottom {
	height: 25px;
	margin: 15px 0 11px;
	span{
		margin-left: 15px;
		font-size: 12px;
	}
	small{
		font-size: 12px;
		margin: 0 5px;
	}
}

.bonus-top-bottom>div {
	float: right;
	font-size: 0;
}

.bonus-bottom {
	position: relative;
	height:calc(~"100% - 215px - 11px");
	
}

.bonus-bottom-title {
	position: absolute;
	top: -30px;
	left: 31px;
	width: 80px;
	height: 28px;
	border-bottom: 2px solid #01b6ad;
	font-size: 14px;
	line-height: 28px;
	color: #01b6ad;
	letter-spacing: 1.55px;
	text-align: center;
}

#bill {
	background: #ffffff;
	box-shadow: 0px 0px 2px 0px rgba(128, 128, 128, 0.50);
	width: 960px;
	height: 400px;
	position: absolute;
	z-index: 100;
}

.bill-header {
	background: #f0f0f0;
	box-shadow: inset 0px -1px 0px 0px rgba(183, 183, 183, 0.50);
	height: 36px;
	font-size: 14px;
	color: #4d4d4d;
	letter-spacing: 0.72px;
	line-height: 36px;
	padding-left: 11px;
}

.bill-header>s {
	position: absolute;
	width: 14px;
	height: 14px;
	right: 11px;
	top: 11px;
	background: url("~src/assets/image/cross.png") no-repeat;
	cursor: pointer;
}

#bill>table tr {
	height: 40px;
}

#bill>table td {
	font-size: 14px;
	color: #323232;
	letter-spacing: 0.99px;
	text-align: left;
	padding: 0 45px 0 34px;
	text-align: center;
	border-top: 1px solid #e6e6e6;
}

#bill>table tbody td {
	font-size: 12px;
	color: #808080;
	letter-spacing: 1.33px;
}

#bill>table tr>td:last-of-type {
	min-width: 250px;
	padding: 0 0 0 45px;
	text-align: left;
}

#bill>table .sum {
	font-size: 14px;
	color: #3b3b3b;
	letter-spacing: 0.99px;
	text-align: left;
}

#bill>table .tax {
	font-size: 14px;
	color: #4a90e2;
	letter-spacing: 1.16px;
	cursor: pointer;
}

.btn-group {
	position: absolute;
	right: 29px;
	bottom: 19px;
	font-size: 0;
}

.btn-group button {
	background: #cbcbcb;
	border-radius: 2px;
	font-size: 12px;
	width: 72px;
	height: 29px;
	color: #fff;
	margin-left: 20px;
	cursor: pointer;
}

.btn-group button.confirm {
	background: #108ee9;
}

#successOpen {
	box-shadow: 0px 0px 3px 0px #b3b3b3;
	border-radius: 0px 2px 2px 2px 2px;
	position: absolute;
	width: 280px;
	height: 150px;
	background-color: #fff;
	z-index: 200;
}

#successOpen>.successHead {
	background: #f2f2f2;
	height: 24px;
	font-size: 12px;
	color: #333333;
	letter-spacing: 0.99px;
	line-height: 24px;
	padding-left: 8px;
}

#successOpen>.successHead s {
	position: absolute;
	right: 7px;
	top: 7px;
	width: 10px;
	height: 10px;
	background: url("~src/assets/image/crossSmall.png") no-repeat;
	cursor: pointer;
}

#successOpen>.successContent {
	text-align: center;
	padding-top: 25px;
	border-bottom: 1px solid #f2f2f2;
}

#successOpen>.successContent>p:nth-of-type(1) {
	font-size: 14px;
	color: #333333;
	letter-spacing: 1.16px;
	line-height: 14px;
	margin-bottom: 10px;
}

#successOpen>.successContent>p>i {
	display: inline-block;
	height: 14px;
	width: 14px;
	margin-right: 8px;
	background: url("~src/assets/image/rightGreen.png") no-repeat;
	cursor: pointer;
}

#successOpen>.successContent>p:nth-of-type(2) {
	height: 10px;
	font-size: 10px;
	color: #333333;
	letter-spacing: 0.83px;
	margin-bottom: 28px;
}

.successBtn>div {
	background: #108ee9;
	border-radius: 2px;
	width: 48px;
	height: 18px;
	font-size: 10px;
	color: #ffffff;
	letter-spacing: 1.11px;
	text-align: center;
	margin: 10px auto;
	cursor: pointer;
}




/* 温馨提示 */

span.question {
	display: inline-block;
	width: 14px;
	height: 14px;
	font-size: 12px;
	background: url("~src/assets/image/description.png") no-repeat;
	cursor: pointer;
	transform: translate(2px, 2px)
}

p span.question .questionBox {
	position: absolute;
	right: -16px;
	top: 10px;
	width: 188px;
	height: 102px;
	background: url("~src/assets/image/box.png") no-repeat;
}

.question .questionBox p {
	padding: 0 20px;
	margin-top: 40px;
	text-align: left;
}
</style>






// WEBPACK FOOTER //
// page-personalTicket.vue?0bfdef34